module.exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valige \xfcksus`,
    "tableResizer": `Suuruse muutja`
};


//# sourceMappingURL=et-EE.main.js.map
